import styled from "styled-components";
import { getMobileBreakpoint } from "../Styles/globals";

export type ImageProps = {
  className?: string;
  src: string;
  width?: number;
  height?: number;
  mobileMargin?: string;
  mobileHeight?: number;
  mobileWidth?: number;
  alt: string;
};

const StyledImageContainer = styled.img<{
  $width: string;
  $height: string;
  $mobileMargin?: string;
  $mobileWidth: string;
  $mobileHeight: string;
}>`
  display: inline-block;
  width: ${(props) => props.$width};
  height: ${(props) => props.$height};
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  @media (max-width: ${getMobileBreakpoint}) {
    height: ${(props) => props.$mobileHeight};
    width: ${(props) => props.$mobileWidth};
    margin: ${(props) => props.$mobileMargin};
  }
`;

export default function Image(props: ImageProps) {
  return (
    <StyledImageContainer
      className={props.className}
      $width={props.width ? `${props.width}px` : "auto"}
      $height={props.height ? `${props.height}px` : "auto"}
      $mobileWidth={props.mobileWidth ? `${props.mobileWidth}px` : "auto"}
      $mobileHeight={props.mobileHeight ? `${props.mobileHeight}px` : "auto"}
      $mobileMargin={props.mobileMargin}
      src={props.src}
      alt={props.alt}
    />
  );
}
